// extracted by mini-css-extract-plugin
export var ContactBtn = "ContactForm-module--ContactBtn--2c02a";
export var ContactFormContainer = "ContactForm-module--ContactFormContainer--fcf1b";
export var ContactFormWrap = "ContactForm-module--ContactFormWrap--27e3e";
export var addressContent = "ContactForm-module--addressContent--aacec";
export var addressContentItem = "ContactForm-module--addressContentItem--df8cf";
export var captcha = "ContactForm-module--captcha--d0f4a";
export var closeIcon = "ContactForm-module--closeIcon--7a978";
export var contactAddressContainer = "ContactForm-module--contactAddressContainer--0eae5";
export var contactBannerContainer = "ContactForm-module--contactBannerContainer--5f15a";
export var contactForm = "ContactForm-module--contactForm--36c8f";
export var contactFormHead = "ContactForm-module--contactFormHead--a998b";
export var contactFormInput = "ContactForm-module--contactFormInput--7500b";
export var contactTextArea = "ContactForm-module--contactTextArea--df413";
export var contentContainer = "ContactForm-module--contentContainer--47e32";
export var contentInnerContainer = "ContactForm-module--contentInnerContainer--57e0c";
export var errorContainer = "ContactForm-module--errorContainer--21a33";
export var errorIcon = "ContactForm-module--errorIcon--bdbdb";
export var errorMessage = "ContactForm-module--errorMessage--02c7c";
export var errorMessages = "ContactForm-module--errorMessages--1ae6a";
export var formHeading = "ContactForm-module--formHeading--d4a89";
export var mainContainer = "ContactForm-module--mainContainer--ad536";
export var mapContainer = "ContactForm-module--mapContainer--1b48a";
export var successMessage = "ContactForm-module--successMessage--78b3c";
export var videoContainer = "ContactForm-module--videoContainer--a1c3c";